'use client';

import { useEffect, useState } from 'react';

/** iOS 软键盘不会始终缩小 dvh，使用实际可见视口保持输入区可达。 */
export function useVisualViewportHeight(enabled: boolean) {
  const [height, setHeight] = useState<number>();
  useEffect(() => {
    if (!enabled) { setHeight(undefined); return; }
    const viewport = window.visualViewport;
    let frame: number | undefined;
    const measure = () => {
      if (frame !== undefined) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        frame = undefined;
        // 双指缩放只放大画面，不按缩小后的可视区域重新排版。
        if (viewport && viewport.scale > 1) return;
        setHeight(Math.round(viewport?.height || window.innerHeight));
      });
    };
    measure();
    viewport?.addEventListener('resize', measure);
    window.addEventListener('resize', measure);
    return () => {
      if (frame !== undefined) window.cancelAnimationFrame(frame);
      viewport?.removeEventListener('resize', measure);
      window.removeEventListener('resize', measure);
    };
  }, [enabled]);
  return enabled ? height : undefined;
}
